import { render, staticRenderFns } from "./FormTexto.vue?vue&type=template&id=1bd66e2b&scoped=true"
import script from "./FormTexto.vue?vue&type=script&lang=js"
export * from "./FormTexto.vue?vue&type=script&lang=js"
import style0 from "./FormTexto.vue?vue&type=style&index=0&id=1bd66e2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd66e2b",
  null
  
)

export default component.exports